// Copied from Ascend
import { Link, LinkProps, useMultiStyleConfig } from "@chakra-ui/react";
import React from "react";
import { Link as RouterLink } from "react-router-dom";

import { RouteTabsContext } from "./RouteTabs";

export interface RouteTabProps extends LinkProps {
  children: React.ReactNode;
  routeName: string;
  href: string;
}

/**
 * The Tab component that is controlled by the router.
 *
 * @param props `RouteTabProps`
 * @param props.routeName The name of the route that will enable the tab.
 * @param props.href The full path to the tab route
 * @example <RouteTab routeName="summary" href="/margin-processing/details/summary">Summary</RouteTab>
 */
export const RouteTab = ({
  children,
  routeName,
  href,
  ...restProps
}: RouteTabProps) => {
  const { routeParam } = React.useContext(RouteTabsContext);
  const isSelected = routeName === routeParam;
  const styles = useMultiStyleConfig("Tabs", restProps);
  return (
    <Link
      as={RouterLink}
      to={href}
      __css={styles.tab}
      bg="gray.100"
      aria-selected="false"
      textDecor="none"
      _hover={{ textDecor: "none" }}
      px={4}
      py={2}
      fontSize="md"
      borderBottomWidth={1}
      borderColor="gray.400"
      marginBottom="-1px"
      roundedTop="md"
      data-testid={`tab-${routeName}`}
      {...(isSelected && {
        bg: "gray.50",
        border: "1px solid",
        borderBottomColor: "gray.50",
        borderLeftColor: "gray.400",
        borderTopColor: "gray.400",
        borderRightColor: "gray.400",
        fontWeight: "bold",
        "aria-selected": true,
      })}
      {...restProps}
    >
      {children}
    </Link>
  );
};
